import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'ImageSet',
      component: () => import('./components/PostImage.vue')
    },
    {
      path: '/view',
      name: 'view',
      component: () => import('./components/CheckImage.vue')
    },
    {
      path: '/user_info',
      name: 'UserInfo',
      component: () => import('./components/UserInfo.vue'),
    },
    {
      path: '/user_all',
      name: 'UserAll',
      component: () => import('./components/UserAll.vue'),
    },
    {
      path: '/group_mng',
      name: 'GroupMng',
      component: () => import('./components/GroupMng.vue'),
    },
    {
      path: '/const_mng/:groupId',
      name: 'ConstMng',
      component: () => import('./components/ConstMng.vue'),
      props: true
     },
    {
      path: '/const_set',
      name: 'ConstSet',
      component: () => import('./components/ConstSet.vue'),
     },
    {
      path: '/detection_set',
      name: 'DetectionSet',
      component: () => import('./components/DetectionSet.vue')
    },
    {
      path: '/grain_index_set',
      name: 'GrainIndexSet',
      component: () => import('./components/GrainIndexSet.vue')
    },
    {
      path: '/job_mng',
      name: 'JobMng',
      component: () => import('./components/JobMng.vue')
    },
    {
      path: '/parameter_mng',
      name: 'ParaMng',
      component: () => import('./components/ParaMng.vue')
    },
  ],
})

